<template>
  <div class="full-area">
    <header
      class="question-header"
    >
      <h2>{{data.fields.title}}</h2>
    </header>

    <content class="content delay-entry">
      <div class="grid-wrapper">
        <div
          :span="12"
          v-for="item in data.fields.options"
          class="option-box"
          :key="item"
          :class="{'standoutx': form.selected === item || form.selected.includes(item)}"
          @click="toggleThis(item)"
        >{{item}}<i class="el-icon-check icon-inside"></i></div>
      </div>
    </content>

    <SkipQuestionButton
      :align-left="validAnswers > 1"
      :disable-submit-button="!inputIsValid"
      :show-submit="validAnswers > 1"
      v-on:skip="skipQuestion()"
      v-on:submit="submitQuestion()"
    ></SkipQuestionButton>
  </div>
</template>

<script>
export default {
  name: 'Bilderset',

  props: [ 'data' ],

  components: {
    SkipQuestionButton: () => import('Components/base/SkipQuestionButton')
  },

  data () {
    return {
      form: {
        question: this.data.fields.title,
        weighted: null,
        weightedMin: [],
        weightedMax: [],
        id: this.data.sys.id,
        selected: [],
        timeToCompletion: null,
        timestamps: {
          start: new Date(),
          finish: null,
          valid: null
        }
      }
    }
  },

  computed: {
    validAnswers () {
      if (this.data.fields.validAnswers <= this.data.fields.options.length) {
        return this.data.fields.validAnswers
      } else {
        return 1
      }
    },
    inputIsValid () {
      if (this.form.selected.length >= 1 && this.form.selected.length <= this.validAnswers) {
        return true
      } else {
        return false
      }
    }
  },

  methods: {
    skipQuestion () {
      this.form.selected = ['NS/NR']
      this.next()
    },
    submitQuestion () {
      this.next()
    },
    toggleThis (item) {
      if (!this.form.selected.includes(item)) {
        if (this.form.selected.length < this.validAnswers) {
          this.form.selected.push(item)
        }
      } else {
        this.form.selected = this.form.selected.filter(el => {
          return el !== item
        })
      }
    },
    calculateScores () {
      if (!this.data.fields.formula) {
        return
      }
      this.$store.dispatch('CALCULATE_WEIGHTED_QUESTION', {
        formula: this.data.fields.formula,
        selected: this.form.selected,
        options: this.data.fields.options,
        maxAnswers: this.data.fields.validAnswers
      }).then(scores => {
        this.form.weighted = scores.weighted.slice(0)
        this.form.weightedMin = scores.weightedMin
        this.form.weightedMax = scores.weightedMax
      }).catch(err => {
        console.log('err: ', err)
      })
    },
    next () {
      if (this.inputIsValid) {
        this.form.timestamps.valid = new Date()
        this.form.timeToCompletion = this.form.timestamps.valid.getTime() - this.form.timestamps.start.getTime()
      } else {
        return
      }
      this.form.timestamps.finish = new Date()
      this.calculateScores()
      this.$emit('next', this.form)
    }
  },

  watch: {
    // Add a simple watch to trigger next automatically after some ms
    'form.selected': function (newVal, oldVal) {
      if (this.inputIsValid && this.validAnswers === 1) {
        setTimeout(() => {
          this.next()
        }, 200)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .option-box {
    font-size: 1.2em;
    display: block;
    width: 100%;
    background: $gray-light;
    padding: 0.5em 1em;
    text-align: left;
    margin-bottom: 10px;
    position: relative;
    border-radius: 5px;
    transition: background-color 0.2s ease-in-out;

    &.standoutx {
      background-color: rgba($color-emphasis-alt, 0.2);
      .icon-inside {
        opacity: 1;
      }
    }
  }
</style>
